export default {
    'future':'未来人才培养计划',

    'Free':'免费试听课报名表',
    'name':'家长昵称',
    'phone': '电话号码',
    'email':'电子邮件',
    'wechat':'微信号(optional)',
    'nowechat':'非微信名',
    'submit':'提交',

    'hotjoin':'火热报名中',
    
    'age':'学员年龄',
    'time':'课程时间',
    'day':'10天/共40节课',
    'type':'课程形式',
    'online':'美国老师线上互动',
    'live':'直播',
    'small':'课程小班55分钟',

    'freetrial':'免 费 试 课',

    'math':'奥数',
    'Drawing':'数码绘画',
    'Coding':'编程',
    'Literature':'经典英语文学阅读',

    'SUMMER CAMP':'SUMMER CAMP',

    'children':'孩子能获得什么',

    'thinking':'逻辑思维能力',
    'empathy':'理解共情能力',
    'Imagination':'想象力',
    'Creativity':'创造力',
    'Social':'社交能力',

    'enrichment':'美国老师线上互动直播授课',
    'certification':'严选Top 5%美国中小学在职教师',

    'summer':'Classover夏令营',
    'society':'面向未来社会，全方位培养人才',
    
    'title_1':'My daughter has attended classover…',
    'comment_1':'My daughter has attended classover class for more than one year. She likes it a lot...',
    'title_1':'Interesting classes',
    'comment_2':'My son is taking reading writing and math classes for more than 1 year. He really enjoys learning..',
    "ctitle_3":"I especially like classover's small…",
    "comment_3":"I especially like classover's small class system, so that every child can be asked questions many times...",
    "Country Code":"国家区号",
    "Please select your country code":"请选择国家区号",
    "Please select your country code":"请选择国家区号",
    "Please verify and enter the text in the picture":"请进行验证,输入图片内的文字",
    "The Verification Code can not be empty":"验证码不能为空",
    "Please enter the contents":"请输入内容",
    "Success":"确定",
    "Click Refresh Verification Code":"点击刷新验证码",
    "Congratulations!":"恭喜您！",
    "You have claimed a free trial lesson":"成功获得了一节免费试听课机会",
    "Our Course Adviser will contact you shortly":"我们的课程顾问老师稍后会和您联系",

}



// WEBPACK FOOTER //
// ./src/locales/zh_CN.js